<i18n src="@/i18n/template/components/DatePickerComponent.json"></i18n>
<template>
  <span class="date-picker-component">
    <span
      style="margin-right: 10px; color: #333; font-size: 14px; font-weight: 500"
      >{{ $t('By') }}</span
    >
    <el-select :value="by" @input="onTypeChange" style="margin-right: 12px">
      <el-option :value="TimeType.Day" :label="$t('Daily')"></el-option>
      <el-option :value="TimeType.Month" :label="$t('Monthly')"></el-option>
      <el-option
        v-if="!hideQuarter"
        :value="TimeType.Quarter"
        :label="$t('Quarterly')"
      ></el-option>
      <el-option :value="TimeType.Year" :label="$t('Yearly')"></el-option>
    </el-select>
    <quarter-picker
      v-if="by === TimeType.Quarter"
      :value="localValue"
      @change="onDateChange"
      :max="maxDate"
      type="range"
    />
    <year-picker
      v-else-if="by === TimeType.Year"
      :value="localValue"
      @change="onDateChange"
      :max="maxDate"
      type="range"
    />
    <el-date-picker
      v-else
      :value="localValue"
      :type="datePickerType"
      :format="
        by === TimeType.Month
          ? $date.elementTemplate.YearMonth
          : $date.elementTemplate.YearMonthDay
      "
      @input="onDateChange"
      :picker-options="datepickerOptions"
    ></el-date-picker>
  </span>
</template>

<script>
import dayjs from 'dayjs'
export const TimeType = {
  Day: '1',
  Month: '2',
  Quarter: '3',
  Year: '4'
}
export default {
  props: {
    by: {
      type: String,
      required: true
    },
    startDt: {
      type: [Date, String],
      required: false
    },
    endDt: {
      type: [Date, String],
      required: false
    },
    maxDate: {
      type: [Number, Date],
      required: true
    },
    datepickerOptions: {
      type: Object,
      required: true
    },
    hideQuarter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    datePickerType() {
      if (this.by === TimeType.Day) {
        return 'daterange'
      }
      if (this.by === TimeType.Month) {
        return 'monthrange'
      }
      return 'daterange'
    },
    localValue() {
      let value = []
      if (this.by === TimeType.Quarter) {
        if (this.startDt && this.endDt) {
          value.push(dayjs(this.startDt).format('YYYYMM'))
          value.push(dayjs(this.endDt).format('YYYYMM'))
        }
        return value
      }
      if (this.by === TimeType.Year) {
        if (this.startDt && this.endDt) {
          value.push(dayjs(this.startDt).format('YYYY'))
          value.push(dayjs(this.endDt).format('YYYY'))
        }
        return value
      }
      return [this.startDt, this.endDt]
    }
  },
  data() {
    return {
      TimeType
    }
  },
  methods: {
    onTypeChange(by) {
      this.$emit('update:by', by)
      this.$emit('update:startDt', '')
      this.$emit('update:endDt', '')
    },
    onDateChange(value) {
      if (!value) {
        this.$emit('update:startDt', '')
        this.$emit('update:endDt', '')
        return
      }
      const maxDay = 31
      const [startDt, endDt] = this.valueToDate(value)
      if (
        this.by === this.TimeType.Day &&
        dayjs(endDt).diff(dayjs(startDt), 'day') > maxDay
      ) {
        this.$emit('update:startDt', '')
        this.$emit('update:endDt', '')
        this.$message.error(
          this.$t('TheSearchConditionMustBeWithin30Days', { day: maxDay })
        )
        return
      }
      this.$emit('update:startDt', startDt)
      this.$emit('update:endDt', endDt)
      this.$emit('change', [startDt, endDt])
    },
    valueToDate(value) {
      const maxDate = dayjs(this.maxDate).endOf('day')
      let [startDt, endDt] = value
      if (this.by === this.TimeType.Quarter) {
        startDt = dayjs(
          `${startDt.substring(0, 4)}-${startDt.substring(4, 6)}-01`
        ).toDate()
        endDt = dayjs(`${endDt.substring(0, 4)}-${endDt.substring(4, 6)}-01`)
          .add(2, 'month')
          .endOf('month')
          .toDate()
      } else if (this.by === this.TimeType.Year) {
        startDt = dayjs(`${startDt}-01-01`).toDate()
        endDt = dayjs(`${endDt}-12-31`).toDate()
      } else if (this.by === this.TimeType.Month) {
        endDt = dayjs(endDt).endOf('month').toDate()
      }
      if (dayjs(endDt).isAfter(maxDate)) {
        endDt = maxDate.toDate()
      }
      return [startDt, endDt]
    }
  }
}
</script>
<style lang="scss">
.date-picker-component {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
